import React from "react";
import types from "prop-types"
import clsx from "clsx"

const URL_REGEX = /(https?:\/\/[^\s<]+[^\s<.,;:!?)}\]'"]|www\.[^\s<]+[^\s<.,;:!?)}\]'"])/

const linkifyText = (text) => {
  if (!text) return text
  const parts = text.split(URL_REGEX)
  return parts.map((part, i) => (URL_REGEX.test(part) ? (
    <a
      href={part.startsWith("http") ? part : `https://${part}`}
      // eslint-disable-next-line react/no-array-index-key
      key={`${i}-${part}`}
      target="_blank"
      rel="noreferrer"
      className="customLink break-all"
    >
      {part}
    </a>
  ) : (
    part
  )))
}

const TextLinkDecorator = ({
  name = "text-link-decorator",
  value = "",
  className = "",
}) => (
  <pre name={name} value={value} className={clsx("formatted-note", className)}>
    {linkifyText(value)}
  </pre>
)

TextLinkDecorator.propTypes = {
  name: types.string,
  value: types.string,
  className: types.string,
}

export default TextLinkDecorator
